import axios from "axios";
import React, { useEffect, useState } from "react";
import bookimg from "../Assest/books.jpg"
import { Buffer } from "buffer";
import cystyle from "../Styles/Cycles.css"
import Loading from "./Loading";
const Books= () =>{
    const[data,setData] = useState([]);
    const[loading,setLoading] = useState(true);
    useEffect(()=>
    {
        axios.get('https://bechnaabackend.onrender.com/books')
        .then((res)=> setData(res.data))
        .catch((err)=> console.log(err,'thereeeeeeeeeeeee issssssssss proooooooooooblem'));
        //setLoading(false);
    });
    //set time out
    function handleLoad() {
      setLoading(false);
    }
      return (
        <>
        {loading && <Loading/>}
       <div className='row'>
          {
              data.map((item)=>
              {
                  let tdata = item.image.data.data;
                  const base64String = Buffer.from(tdata).toString('base64');
    
                  return <div className="column" key={item._id}>  
                              <img src={`data:image/png;base64,${base64String}`  } alt="cycle" onLoad={handleLoad}  />
                              <div className="prodetails">
                                   <p>Details: {item.name}</p>
                                   <p>Price: {item.price}/-</p>
                                   <button onClick={(e)=>{alert(item.phno)}}>Connect with Seller</button>
                              </div>
                           </div>
              })
          }
        </div>
        </>
      );
}

export default Books;